import { InputHTMLAttributes } from "react";
import { FieldError } from "react-hook-form";
import inputErroricon from "../../assets/task/inputerror_icon.svg";

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: FieldError;
}

const Input = ({ label, error, ...props }: InputProps) => {
  return (
    <div className="mb-4">
      {label && <label className="block text-sm font-medium mb-1">{label}</label>}
      <input
        {...props}
        className={`w-full p-2 border rounded outline-none ${
          error ? "border-red-500" : "border-gray-300"
        }`}
      />
      {error && <p className="text-red-500 text-sm mt-1">   <img src={inputErroricon} className="w-2 h-2" alt="" /> {error.message}</p>}
    </div>
  );
};

export default Input;